import { PieChart, Pie, Cell, Legend } from 'recharts';
import config from '../../config';
import { objectToArray } from '../../utils';

export default function DonutPlot({ data, name, displayTotal, isPercent }) {
  const formattedData = objectToArray(data).filter((item) => item.value > 0);

  return (
    <PieChart width={635} height={325}>
      <text
        className='pie-text'
        x={config.plots.donut[name].positions.pieX}
        y={config.plots.donut[name].positions.textY}
      >
        {displayTotal}
      </text>
      <Pie
        isAnimationActive={false}
        data={formattedData}
        labelLine={false}
        paddingAngle={1}
        innerRadius={90}
        outerRadius={150}
        dataKey='value'
        stroke='none'
        cx={config.plots.donut[name].positions.pieX}
        cy={'50%'}
      >
        {formattedData.map((entry, index) => (
          <Cell key={index} fill={config.plots.donut.colors[entry['name']]} />
        ))}
      </Pie>
      <Legend
        iconSize='7'
        layout='vertical'
        verticalAlign='middle'
        wrapperStyle={{
          left: config.plots.donut[name].positions.legendLeft,
          top: `${50 - formattedData.length * 3}%`
        }}
        payload={formattedData.map((item) => ({
          type: 'square',
          value: `${item.name} (${item.value}${isPercent ? '%' : ''})`,
          color: config.plots.donut.colors[item.name]
        }))}
      />
    </PieChart>
  );
}
